import type React from "react";
import type { CalendarEvent } from "@/types/calendarEvent";
import {
	getLocationImage,
	getLocationName,
	formatTimeRange,
} from "../../../../../utils/googleCalendar";
import { Link } from "react-router-dom";

interface EventCardProps {
	event: CalendarEvent;
}

const EventCard: React.FC<EventCardProps> = ({ event }) => {
	return (
		<div className="bg-white rounded-lg shadow-md overflow-hidden">
			<img
				src={getLocationImage(event.location || "")}
				alt={event.summary}
				className="w-full h-48 object-cover"
			/>
			<div className="p-6">
				<h3 className="text-xl font-semibold mb-4">{event.summary}</h3>
				<p className="mb-2">
					開催日: {new Date(event.start.dateTime).toLocaleDateString()}
				</p>
				<p className="mb-2">
					時間: {formatTimeRange(event.start.dateTime, event.end.dateTime)}
				</p>
				<p>
					場所:{" "}
					{event.location ? (
						<Link
							to={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
								event.location,
							)}`}
							target="_blank"
							rel="noopener noreferrer"
							className="text-blue-500 hover:underline"
							title="マップを表示します"
						>
							{getLocationName(event.location)}
						</Link>
					) : (
						"未定"
					)}
				</p>
			</div>
		</div>
	);
};

export default EventCard;
